import { IReleaseNote } from "../types"

export const RELEASE_1_6_0: IReleaseNote = {
    status: "UPCOMING",
    title: "v1.6.0",
    date: "9 June 2025",
    releaseType: "Minor",
    notesBodyAllUsers: [
        {
            heading: "Introduction",
            content:
                "We are excited to announce ENA Connect Direct 1.6.0. We are targeting a release for the 9th June 2025. This is a minor release, and it contains new features to make the site better, faster and more accurate. These notes outline the key changes.",
        },
    ],
    notesBodyInstaller: [
        {
            heading: "For installers using the web portal",
            subtitle: "Feature Summary",
            bullets: [
                "MFA: Will give admins the ability to reset the MFA code for their users. That way the user will be able to contact their admin for a password reset rather than the support team.",
                "Inverter Type Selection: This feature expands the range of selectable inverter types on Connect Direct improving device category handling. It ensures a smoother installer experience while maintaining high-quality connection data and will make more devices available within the application device selection",
                "Additional Filters: This feature enhances application search and management by introducing new filtering options for DNOs and installers",
                "Application Duplication Detection: Addresses the issue of multiple applications being raised for the same MPAN, which are currently treated as separate applications and counted twice. The feature will detect potential duplicate applications, flag them to the installer, and then escalate to the DNO, who can take appropriate action.",
                "Application and Devices - Comments read/unread: Addresses the need for users to easily identify applications or devices with unread comments, preventing comments from being overlooked. It also introduces the ability to surface applications with comments",
                "Advance Device Search: Enables advanced querying of the Live Device Register with enhanced filtering capabilities for both demand and generation devices",
            ],
        },
        {
            heading: "The following changes are to be added:",
            subtitle: "MFA reset:",
            bullets: [
                "Admins can reset Multi-Factor Authentication (MFA) for their user base",
                "When MFA is reset, user permissions are also reset to prevent an 'MFA-less' account from retaining full permissions and enabling MFA reset to be completed in ‘one click’",
            ],
        },
        {
            subtitle: "Inverter Type:",
            bullets: [
                "The decision login will be updated to remove 'device type' validation, ensuring no tight coupling between application type and device types for generation applications.",
                "All devices within TTR are searchable and selectable by installers.",
                "Exclusion of the G100 ELS devices in the supply details section",
            ],
        },
        {
            subtitle: "Additional Filters:",
            bullets: [
                "Filters such as Looped Supply, Supply Issues, and Installer, amongst others, are added to the installer 'My Applications' page",
            ],
        },
        {
            subtitle: "Application Duplication Detection:",
            bullets: [
                "An application is considered a duplicate if it occurs within 2 weeks of another at the same MPAN, with this window fixed for all",
                "Installers will be notified if a duplicate is detected by a pop-up post submission with options to review, save as draft, submit, or cancel.",
                "Within the application summary page, you will be able to view the 'Duplicate Applications' section, which lists all potential duplicates and links you to those applications",
                "Applications undergoing re-assessment due to amendments will not be flagged as duplicates, and draft applications do not influence the duplicate detection process",
            ],
        },
        {
            subtitle: "Application and Devices - Comments read/unread:",
            bullets: [
                "Enables installers to add comments flagged as unread for the DNO. DNOs and installers can view applications with unread comments and filter them accordingly.",
                "From the single application summary page, users can toggle a comment thread as 'read/unread' and see who last read it and when",
                "Any installer/DNO user with access to the application can toggle comments as read/unread.",
                "No emails or notifications will be sent during this process.",
            ],
        },
        {
            subtitle: "Advanced Device Search:",
            bullets: [
                "Users will be able to perform more precise searches using additional filters and seamlessly add devices to their applications during the ‘Existing Devices’ and ‘New Devices’ stages of the application journey. The following filters will be added to both the TTR and LCT device searches: Manufacturer, Model, Max Device Demand (range), Phase, Category, and Type. An additional Voltage filter will be available specifically in the LCT search",
            ],
        },
        {
            heading: "For installers using our APIs",
            subtitle: "Feature Summary",
            bullets: [
                "Inverter Type Selection: This feature expands the range of selectable inverter types on Connect Direct improving device category handling. It ensures a smoother installer experience while maintaining high-quality connection data and will make more devices available within the application device selection",
                "Additional Filters: This feature enhances application search and management by introducing new filtering options for installers with the addition of optional query parameters",
                "Application Duplication Detection: Addresses the issue of multiple applications being raised for the same MPAN, which are currently treated as separate applications and counted twice. The feature will detect duplicate applications, flag them to the installer, and then escalate to the DNO, who can take appropriate action",
                "Application and Devices - Comments read/unread: Addresses the need for users to easily identify applications or devices with unread comments, preventing comments from being overlooked. It also introduces the ability to surface applications with comments",
                "Advance Device Search: Enables advanced querying of the Live Device Register with enhanced filtering capabilities for both demand and generation devices",
            ],
        },
        {
            heading: "The following changes are to be added:",
        },
        {
            subtitle: "Inverter Type:",
            bullets: [
                "The decision login will be updated to remove 'device type' validation, ensuring no tight coupling between application type and device types for generation applications.",
                "All devices within TTR are searchable and selectable by installers.",
                "Exclusion of the G100 ELS devices in the supply details section",
            ],
        },
        {
            subtitle: "Additional Filters:",
            bullets: [
                "New Filters will include: Address, Post Code, Installer, Gen Capacity, Total Demand, Technology, Looped Supply, Supply Issues, Date last updated",
            ],
        },
        {
            subtitle: "Application Duplication Detection:",
            bullets: [
                "An application is considered a duplicate if it occurs within 2 weeks of another at the same MPAN, with this window fixed for all",
                "Installers will be notified if a duplicate is detected by a pop-up post submission with options to review, save as draft, submit, or cancel.",
                "The application creation endpoint will return a new custom error code for detected duplicates Error code: 409 - duplicate detected. This can be bypassed by setting a new optional parameter `rejectDuplicate` to False (default value)",
                "Applications undergoing re-assessment due to amendments will not be flagged as duplicates, and draft applications do not influence the duplicate detection process",
            ],
        },
        {
            subtitle: "Application and Devices - Comments read/unread:",
            bullets: [
                "Enables installers to add comments flagged as unread for the DNO. DNOs and installers can view applications with unread comments and filter them accordingly.",
                "From the single application summary page, users can toggle a comment thread as 'read/unread' and see who last read it and when",
                "Any installer/DNO user with access to the application can toggle comments as read/unread.",
                "No emails or notifications will be sent during this process.",
            ],
        },
        {
            subtitle: "Advanced Device Search:",
            bullets: [
                "Additional filtering options—such as Manufacturer, Model, Max Device Demand (range), Phase, Category, and Type—will be available as optional query parameters for both the TTR and LCT device searches. The LCT search will also include a Voltage filter",
            ],
        },
    ],
    notesBodyDno: [
        {
            heading: "For DNOs using the web portal",
            subtitle: "Feature Summary",
            bullets: [
                "MFA: Will give admins the ability to reset the MFA code for their users. That way the user will be able to contact their admin for a password reset rather than the support team.",
                "Additional Filters: This feature enhances application search and management by introducing new filtering options for DNOs and installers",
                "Application Duplication Detection: As duplicate applications will now be checked within the application process there will be some additional fields available for DNO users to access and view duplicate application information",
                "Application and Devices - Comments read/unread: Addresses the need for users to easily identify applications or devices with unread comments, preventing comments from being overlooked. It also introduces the ability to surface applications with comments",
            ],
        },
        {
            heading: "The following changes are to be added:",
            subtitle: "MFA reset:",
            bullets: [
                "Admins can reset Multi-Factor Authentication (MFA) for their user base",
                "When MFA is reset, user permissions are also reset to prevent an 'MFA-less' account from retaining full permissions and enabling MFA reset to be completed in ‘one click’",
            ],
        },
        {
            subtitle: "Additional Filters:",
            bullets: [
                "New Filters will include: Application ID, Last Updated, Status, Assigned To, Address, Post Code, Installer, Gen Capacity, Total Demand, Technology type, Escalation Reason, Assigned to",
            ],
        },
        {
            subtitle: "Application Duplication Detection:",
            bullets: [
                "An application is considered a duplicate if it occurs within 2 weeks of another at the same MPAN, with this window fixed for all",
                "Within the application summary page, you will be able to view the 'Duplicate Applications' section, which lists all potential duplicates and links you to those applications",
                "Applications undergoing re-assessment due to amendments will not be flagged as duplicates, and draft applications do not influence the duplicate detection process",
                "New DNO assessment flag will be added into the enaAssessment object to detect if a Duplication has been found. This field will be a boolean called `isAppNotDuped` and will be False when a duplicate has been detected.",
                "Within the root of the application object there will also be a new object added called `duplicateApplicationIds` which will list out all applicationIds which have been detected as duplicates",
            ],
        },
        {
            subtitle: "Application and Devices - Comments read/unread:",
            bullets: [
                "Enables installers to add comments flagged as unread for the DNO. DNOs/installers can view applications with unread comments and filter them accordingly.",
                "From the single application summary page, users can toggle a comment thread as 'read/unread' and see who last read it and when",
                "Any installer/DNO user with access to the application can toggle comments as read/unread..",
                "No emails or notifications will be sent during this process.",
                "A new feature allows DNO/ENA users to subscribe to comment threads on specific devices, receiving updates via email.",
            ],
        },
        {
            heading: "For DNOs using our APIs",
            subtitle: "Feature Summary",
            bullets: [
                "Additional Filters: This feature enhances application search and management by introducing new filtering options for DNOs and installers",
                "Application Duplication Detection: As duplicate applications will now be checked within the application process there will be some additional fields available for DNO users to access and view duplicate application information",
                "Application and Devices - Comments read/unread: Addresses the need for users to easily identify applications or devices with unread comments, preventing comments from being overlooked. It also introduces the ability to surface applications with comments",
            ],
        },
        {
            heading: "The following changes are to be added:",
            subtitle: "Additional Filters:",
            bullets: [
                "Filters such as Address, Post Code, Total Demand, and Date Last Updated are added to the DNO 'My Applications' page",
            ],
        },
        {
            subtitle: "Application Duplication Detection:",
            bullets: [
                "An application is considered a duplicate if it occurs within 2 weeks of another at the same MPAN, with this window fixed for all",
                "Within the application summary page, you will be able to view the 'Duplicate Applications' section, which lists all potential duplicates and links you to those applications",
                "Applications undergoing re-assessment due to amendments will not be flagged as duplicates, and draft applications do not influence the duplicate detection process",
            ],
        },
        {
            subtitle: "Application and Devices - Comments read/unread:",
            bullets: [
                "Enables installers to add comments flagged as unread for the DNO. DNOs/installers can view applications with unread comments and filter them accordingly.",
                "From the single application summary page, users can toggle a comment thread as 'read/unread' and see who last read it and when",
                "Any installer/DNO user with access to the application can toggle comments as read/unread..",
                "No emails or notifications will be sent during this process.",
                "A new feature allows DNO/ENA users to subscribe to comment threads on specific devices, receiving updates via email.",
            ],
        },
    ],
    notesBodyManu: [
        {
            heading: "For manufacturers using the web portal",
            subtitle: "Feature Summary",
            bullets: [
                "MFA: Will give admins the ability to reset the MFA code for their users. That way the user will be able to contact their admin for a password reset rather than the support team.",
                "Application and Devices - Comments read/unread: Addresses the need for users to easily identify applications or devices with unread comments, preventing comments from being overlooked.",
            ],
        },
        {
            heading: "The following changes are to be added:",
            subtitle: "MFA reset:",
            bullets: [
                "Admins can reset Multi-Factor Authentication (MFA) for their user base",
                "When MFA is reset, user permissions are also reset to prevent an 'MFA-less' account from retaining full permissions and enabling MFA reset to be completed in ‘one click’",
            ],
        },
        {
            subtitle: "Application and Devices - Comments read/unread:",
            bullets: [
                "Enables Manufacturers to add comment flags as unread for the Evaluator. Manufacturers can view devices with unread comments and filter them accordingly.",
                "From the device summary page, users can toggle a comment thread as 'read/unread' and see who last read it and when",
                "Approved users of the organisation will receive email notifications when a comment has been posted on their device",
            ],
        },
    ],
    notesBodyDbAssessorDemand: [
        {
            heading: "For Demand Assessors using the web portal",
            subtitle: "Feature Summary",
            bullets: [
                "MFA: Will give admins the ability to reset the MFA code for their users. That way the user will be able to contact their admin for a password reset rather than the support team.",
                "Application and Devices - Comments read/unread: Addresses the need for users to easily identify applications or devices with unread comments, preventing comments from being overlooked.",
            ],
        },
        {
            heading: "The following changes are to be added:",
            subtitle: "MFA reset:",
            bullets: [
                "Admins can reset Multi-Factor Authentication (MFA) for their user base",
                "When MFA is reset, user permissions are also reset to prevent an 'MFA-less' account from retaining full permissions and enabling MFA reset to be completed in ‘one click’",
            ],
        },
        {
            subtitle: "Application and Devices - Comments read/unread:",
            bullets: [
                "Enables Assessors to add comment flags as unread for the Manufacturer. Assessors can view devices with unread comments and filter them accordingly.",
                "From the device summary page, users can toggle a comment thread as 'read/unread' and see who last read it and when",
                "Approved users of the organisation will receive email notifications when a comment has been posted on a device",
            ],
        },
    ],
    notesBodyDbAssessorGen: [
        {
            heading: "For Generation Assessors using the web portal",
            subtitle: "Feature Summary",
            bullets: [
                "MFA: Will give admins the ability to reset the MFA code for their users. That way the user will be able to contact their admin for a password reset rather than the support team.",
                "Application and Devices - Comments read/unread: Addresses the need for users to easily identify applications or devices with unread comments, preventing comments from being overlooked.",
            ],
        },
        {
            heading: "The following changes are to be added:",
            subtitle: "MFA reset:",
            bullets: [
                "Admins can reset Multi-Factor Authentication (MFA) for their user base",
                "When MFA is reset, user permissions are also reset to prevent an 'MFA-less' account from retaining full permissions and enabling MFA reset to be completed in ‘one click’",
            ],
        },
        {
            subtitle: "Application and Devices - Comments read/unread:",
            bullets: [
                "Enables Assessors to add comment flags as unread for the Manufacturer. Assessors can view devices with unread comments and filter them accordingly.",
                "From the device summary page, users can toggle a comment thread as 'read/unread' and see who last read it and when",
                "Approved users of the organisation will receive email notifications when a comment has been posted on a device",
            ],
        },
    ],
}
